export const MIN_SMALLER_TEXT_PRICE = 1000;
